import React, {ReactNode} from 'react';
import styled from 'styled-components';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {SimpleDropdownItem} from '../../../../libs/shared/ui/src/components/dropdowns/simpleDropdownItem';
import {StartAndEndDatesWithPeriod} from '../../../models/dates/dateIntervalModel';

/*
 * Styles.
 */

const Period = styled.div`
  grid-area: right-icon;
  margin: 2px 0 0 20px;
  color: ${(p) => p.theme.greys.shade60};
  min-width: 180px;
  text-align: right;
`;

/*
 * Types.
 */

interface DateRangeComboBoxDropdownPeriodItemProps {
  label: ReactNode;
  period: StartAndEndDatesWithPeriod;
  onDateSelect: HandlerOf<StartAndEndDatesWithPeriod>;
}

/*
 * Component.
 */

export const DateRangeComboBoxDropdownPeriodItem = (props: DateRangeComboBoxDropdownPeriodItemProps) => {
  const {period, label, onDateSelect} = props;
  let format = 'MMM d, yyyy';
  let suffix = '';
  if (period.startDate?.year === period.endDate?.year) {
    format = 'MMM d';
    suffix = `, ${period.startDate?.year}`;
  }

  const periodLabel = `${period.startDate?.toFormat(format)}${
    period.endDate ? ` - ${period.endDate?.toFormat(format)}` : ''
  }`;

  const onSelect = () =>
    onDateSelect({
      startDate: period.startDate,
      endDate: period.endDate ?? period.startDate?.endOf('day'),
      period: period.period,
    });

  return (
    <SimpleDropdownItem
      checkmarkLabel={label}
      renderRightContent={() => (
        <Period>
          {periodLabel}
          {suffix}
        </Period>
      )}
      onSelect={onSelect}
    >
      {label}
    </SimpleDropdownItem>
  );
};
